/**
 * Entidad StorePage
 * Páginas de la web de la tienda
 */

export interface StorePage {
  id: string;
  accountId: string;
  type: StorePageType;
  title: string;
  slug: string;
  content?: string | null;
  seoTitle?: string | null;
  seoDescription?: string | null;
  
  status: StorePageStatus;
  canDelete: boolean;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date | null;
}

export enum StorePageStatus {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  ARCHIVED = 'ARCHIVED',
}

export enum StorePageType {
  ABOUT_US = 'ABOUT_US',
  CONTACT = 'CONTACT',
  FAQ = 'FAQ',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  RETURN_POLICY = 'RETURN_POLICY',
  SHIPPING_POLICY = 'SHIPPING_POLICY',
  BRANCHES = 'BRANCHES',
  JOBS = 'JOBS',
  OTHER = 'OTHER',
}


 